/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/credit_line';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "UpdateCreditLineSmartRepaymentSettingsRequest": {
                "fields": {
                  "creditLineId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "smartRepaymentSettings": {
                    "type": ".squareup.corporate_card.resources.CreditLine.SmartRepaymentSettings",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateCreditLineSmartRepaymentSettingsResponse": {
                "fields": {
                  "creditLine": {
                    "type": ".squareup.corporate_card.resources.CreditLine",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateCreditLineSmartRepaymentSettingsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateCreditLineSmartRepaymentSettingsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateCreditLineSmartRepaymentSettingsRequest @ squareup/corporate_card/service/update_credit_line_smart_repayment_settings.proto at 10:1
 */
export const UpdateCreditLineSmartRepaymentSettingsRequest = $root.lookupType('squareup.corporate_card.service.UpdateCreditLineSmartRepaymentSettingsRequest');
fixType(UpdateCreditLineSmartRepaymentSettingsRequest, {
  creditLineId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateCreditLineSmartRepaymentSettingsRequest);
/**
 * SOURCE UpdateCreditLineSmartRepaymentSettingsResponse @ squareup/corporate_card/service/update_credit_line_smart_repayment_settings.proto at 27:1
 */
export const UpdateCreditLineSmartRepaymentSettingsResponse = $root.lookupType('squareup.corporate_card.service.UpdateCreditLineSmartRepaymentSettingsResponse');
fixType(UpdateCreditLineSmartRepaymentSettingsResponse);
Builder.createAndAttachToType(UpdateCreditLineSmartRepaymentSettingsResponse);